import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-notification-counter',
  templateUrl: './notification-counter.component.html',
  styleUrls: ['./notification-counter.component.scss'],
})
export class NotificationCounterComponent {
  @Input() public counterValiant: 'small' | 'regular' = 'regular';
  @Input() public notificationsCounter: number;
  @Input() public isActive$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
}
